// @flow
import PrimaryPalette from '../../colors';

const Theme = {
  default: {
    dividerColor: PrimaryPalette.mediumEvergreen,
  },
};

export default Theme;
